// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__xiHXT","text":"CheckBox_text__cpial","checkbox":"CheckBox_checkbox__cAoQx","path":"CheckBox_path__NmY8m","bounce":"CheckBox_bounce__Gzw8W"};